import { len } from "./common";
export function unlock(unlocked) {
    // "touchstart", "touchend", "mousedown", "pointerdown"
    var events = ["touchstart", "touchend", "mousedown", "click", "keydown"];
    var num = len(events);
    var doc = document;
    var handle = function () {
        if (unlocked()) {
            for (var i = 0; i < num; ++i) {
                doc.removeEventListener(events[i], handle, true);
            }
        }
    };
    for (var i = 0; i < num; ++i) {
        doc.addEventListener(events[i], handle, true);
    }
}
//# sourceMappingURL=Unlock.js.map